import { Icon } from "@chakra-ui/react";
import React from "react";

const ContractIcon = (props) => (
  <Icon viewBox="0 0 15 19" fill="none" {...props}>
    <path d="M3.75 15.25H11.25V13.75H3.75V15.25ZM3.75 11.25H11.25V9.75H3.75V11.25ZM1.80775 19C1.30258 19 0.875 18.825 0.525 18.475C0.175 18.125 0 17.6974 0 17.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H9.75L15 5.25V17.1923C15 17.6974 14.825 18.125 14.475 18.475C14.125 18.825 13.6974 19 13.1923 19H1.80775ZM9 6H13.5L9 1.5V6Z" fill="currentColor" />
  </Icon>
);

export default React.memo(ContractIcon);
